import { useTranslation } from 'react-i18next'

import { Alert, IbanInput, UKBankAccountInput } from '@reveni-io/reveni-ui'

import { currencies } from '@/constants'
import { bankAccountErrorTypes } from '@/hooks/useBankAccount/constants'

import BankAccountUserInfo from './BankAccountUserInfo/BankAccountUserInfo'
import { unsupportedIbanCountries } from './constants'
import * as Styles from './styles'

const CreateBankAccount = ({
  onChange,
  firstName,
  lastName,
  onChangeFirstName,
  onChangeLastName,
  currency,
  bankAccount,
  errorType,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <BankAccountUserInfo
        firstName={firstName}
        lastName={lastName}
        onChangeFirstName={onChangeFirstName}
        onChangeLastName={onChangeLastName}
      />
      {currency === currencies.EUR && (
        <IbanInput
          customError={errorType === bankAccountErrorTypes.IBAN ? { message: 'Número de cuenta no válido.' } : null}
          onChange={onChange}
          fullWidth
          label={t('IBAN')}
          value={bankAccount}
          unsupportedIbanCountries={unsupportedIbanCountries}
        />
      )}
      {currency === currencies.GBP && (
        <UKBankAccountInput onChange={value => onChange({ value, error: null })} value={bankAccount} />
      )}
      {errorType === bankAccountErrorTypes.UK && (
        <Styles.AlertContainer>
          <Alert type="error">
            {t(
              'Los datos de la cuenta introducida no son correctos. Por favor revisa los datos del titular y el numero de cuenta y vuelve a intentarlo.'
            )}
          </Alert>
        </Styles.AlertContainer>
      )}
    </Styles.Container>
  )
}

export default CreateBankAccount
